import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
//import Utils from '../../../custom/utils';
import {API} from "../../../../config";
import _ from 'lodash';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import {connect} from "react-redux";
//import AppBar from '@material-ui/core/AppBar';
//import Toolbar from '@material-ui/core/Toolbar';
//import Typography from '@material-ui/core/Typography';

//const outbound = API.service('withdrawal');
const wallet = API.service('wallet');
const db_utils = API.service('utils');

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        //border:'2px solid ' + theme.navigation.selected.backgroundColor,
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    },
    debutton:{
        padding:'5px 12px',
        //background:theme.navigation.selected.backgroundColor,
        //color:theme.navigation.selected.contrast,
        borderRadius:3,
        boxShadow:'2px 2px 2px #eee',

        '&:hover':{
            //background:theme.navigation.hover.backgroundColor,
            //color:theme.navigation.selected.contrast,
        }
    },
    formControl:{
      width:'100%'
    }
});

class WalletJournal extends Component {
    state={
        amount: 0,
        comment:'',
        currency:'USD',
        journal_type:'JOURNAL'
    };

  fetchAllInvestors = () => {
    const app = this;

    db_utils.find().then(inv =>{
      app.props.context.update({
        investors:inv.result
      })
      console.log(this.props);
    }).catch(e=>{
      console.log('Error Loading:', e);
      app.setState({
        error:'Error: ' + e
      })
    })
  }

    complete = () => {
        const app = this;

        let fund = parseFloat(this.state.amount);
        if( (this.state.journal_type === 'FUNDS-FROZEN' || this.state.journal_type === 'JOURNAL-DEBIT') && fund > 0){
          fund = fund * -1;
        } else if (fund < 0){
          fund = fund * 1;
        }

        let payload =
            {
                _account:this.props.investor._account,
                _fund: fund,
                _comment:this.state.comment,
                _type: this.state.journal_type,
                _reference_id:0,
                _currency: this.state.currency,
                _user_id:this.props.user.data.email
            }

        wallet.create(payload).then(w=>{
            app.props.context.update({
                popupContent: false,
            })
            app.fetchAllInvestors();
        });
    };

    handleChange = (event) => {
      console.log(event.target.name,event.target.value);
        this.setState(_.set({ ...this.state, error: '' }, event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value));
    }

    close = () =>{
        this.props.context.update({
            popupContent: false,
        })
    };

    render() {
        const {classes} = this.props;

        return (
            <React.Fragment>
              <div style={{padding:10}}>
                <b>Investor:</b> {this.props.investor._firstname} {this.props.investor._surname}<br />
                <b>Account:</b> {this.props.investor._account}<br /><br />

                <br />
                <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="age-simple">Journal Type</InputLabel>
                    <Select
                      value={this.state.journal_type}
                      onChange={this.handleChange}
                      inputProps={{
                          name: 'journal_type',
                          id: 'journal_type',
                      }}
                    >
                        <MenuItem value={'JOURNAL'}>JOURNAL</MenuItem>
                        <MenuItem value={'JOURNAL-DEBIT'}>JOURNAL-DEBIT</MenuItem>
                        <MenuItem value={'JOURNAL-CREDIT'}>JOURNAL-CREDIT</MenuItem>
                        <MenuItem value={'FUNDS-FROZEN'}>FUNDS-FROZEN</MenuItem>
                        <MenuItem value={'FUNDS-RELEASED'}>FUNDS-RELEASED</MenuItem>
                    </Select>
                </FormControl>
                <br />
                <FormControl className={classes.formControl}>
                  <InputLabel htmlFor="currency">Currency</InputLabel>
                  <Select
                    value={this.state.currency}
                    onChange={this.handleChange}
                    inputProps={{
                      name: 'currency',
                      id: 'currency',
                    }}
                  >
                    <MenuItem value={'USD'}>USD</MenuItem>
                    <MenuItem value={'EUR'}>EUR</MenuItem>
                    <MenuItem value={'ANG'}>XCG</MenuItem>
                    <MenuItem value={'GBP'}>GBP</MenuItem>
                    <MenuItem value={'IPO'}>IPO</MenuItem>
                  </Select>
                </FormControl>
                <br />
                <FormControl className={classes.formControl}>
                  <TextField
                    id="amount"
                    name="amount"
                    label="Amount"
                    className={classes.textField}
                    value={this.state.amount}
                    onChange={this.handleChange}
                    margin="normal"
                  />
                </FormControl>
                <br />
                <FormControl className={classes.formControl}>
                  <TextField
                    id="comment"
                    name="comment"
                    label="Comment"
                    className={classes.textField}
                    value={this.state.comment}
                    onChange={this.handleChange}
                    margin="normal"
                  />
                </FormControl>
                <br />
                <Button variant="contained" color="secondary" onClick={this.complete}>
                    Complete
                </Button>
                &nbsp;
                <Button variant="outlined" color="secondary" onClick={this.close}>
                    Cancel
                </Button>
              </div>
            </React.Fragment>
        )
    }
}

function mapStateToProps({auth})
{
  return {
    user: auth.user
  }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(WalletJournal))));
